import getBody from './getBody';
import observe from './observe';

const ApexChatTitle = {
    TITLE_FLASH_INTERVAL: 1,
    set(title) {
        document.title = title;
    },
    flash() {
        window.clearInterval(document.flashInterval);
        document.flashInterval = window.setInterval(
            ApexChatTitle.toggle,
            1 * 1000
            // TITLE_FLASH_INTERVAL * 1000
        );
        if (!getBody().monitoredForTitleFlash) {
            observe(window, 'click', ApexChatTitle.stopFlashing);
            observe(getBody(), 'click', ApexChatTitle.stopFlashing);
            observe(getBody(), 'keypress', ApexChatTitle.stopFlashing);
            getBody().monitoredForTitleFlash = true;
        }
    },
    stopFlashing() {
        window.clearInterval(document.flashInterval);
        if (document.originalTitle) {
            document.title = document.originalTitle;
        }
    },
    toggle() {
        if (!document.originalTitle) {
            document.originalTitle = document.title;
        }
        if (document.title == document.originalTitle) {
            document.title = `(New Message) ${document.originalTitle}`;
        } else {
            document.title = document.originalTitle;
        }
    }
};
export default ApexChatTitle;
